module.exports = __webpack_public_path__ + "static/media/DUFQorXXUAU-Ncv.7dadfe80.jpg";